// TODO:
// REMOVER TUDO QUE NÃO FOR REFERENTE AO MERCADO SECUNDÁRIO

export const UPDATE_REQUEST_STATUS_SECONDARY =
  'UPDATE_REQUEST_STATUS_SECONDARY';
export const updateRequestStatusSecondary = (e) => ({
  type: UPDATE_REQUEST_STATUS_SECONDARY,
  payload: e,
});

export const SET_LAUNCHING_YEARS_SECONDARY = 'SET_LAUNCHING_YEARS_SECONDARY';
export const setLaunchingYearsSecondary = (e) => ({
  type: SET_LAUNCHING_YEARS_SECONDARY,
  payload: e,
});

export const UPDATE_REALTY_OFFERS_SECONDARY = 'UPDATE_REALTY_OFFERS_SECONDARY';
export const updateRealtyOffersSecondary = (e) => ({
  type: UPDATE_REALTY_OFFERS_SECONDARY,
  payload: e,
});

export const CHANGE_SEARCH = 'CHANGE_SEARCH';
export const changeSearch = (e) => ({
  type: CHANGE_SEARCH,
  payload: e,
});

export const CLEAR_FILTERS_SECONDARY = 'CLEAR_FILTERS_SECONDARY';
export const clearFiltersSecondary = (e) => ({
  type: CLEAR_FILTERS_SECONDARY,
  payload: e,
});

export const UPDATE_INPUT_INTERVALS_SECONDARY_GENERAL =
  'UPDATE_INPUT_INTERVALS_SECONDARY_GENERAL';
export const updateInputIntervalsSecondaryGeneral = (e) => ({
  type: UPDATE_INPUT_INTERVALS_SECONDARY_GENERAL,
  payload: e,
});

export const UPDATE_PAYLOAD_REQUEST = 'UPDATE_PAYLOAD_REQUEST';
export const updatePayloadRequest = (e) => ({
  type: UPDATE_PAYLOAD_REQUEST,
  payload: e,
});

export const CLOSE_INFOWINDOWS_SECONDARY = 'CLOSE_INFOWINDOWS_SECONDARY';
export const closeInfowindowsSecondary = (e) => ({
  type: CLOSE_INFOWINDOWS_SECONDARY,
  payload: e,
});

export const SET_INFOWINDOWS_SECONDARY = 'SET_INFOWINDOWS_SECONDARY';
export const setInfowindowsSecondary = (e) => ({
  type: SET_INFOWINDOWS_SECONDARY,
  payload: e,
});

export const UPDATE_BUILDING_DATA_SECONDARY = 'UPDATE_BUILDING_DATA_SECONDARY';
export const updateBuildingData = (payload) => ({
  type: UPDATE_BUILDING_DATA_SECONDARY,
  payload,
});

export const UPDATE_CHARTS_DATA_SECONDARY = 'UPDATE_CHARTS_DATA_SECONDARY';
export const updateChartsDataSecondary = (payload) => ({
  type: UPDATE_CHARTS_DATA_SECONDARY,
  payload,
});

export const STORE_CHART_DATA = 'STORE_CHART_DATA';
export const storeChartData = (e) => ({
  type: STORE_CHART_DATA,
  payload: e,
});

export const CLEAR_STORAGED_CHART_DATA_SECONDARY =
  'CLEAR_STORAGED_CHART_DATA_SECONDARY';
export const clearStoragedChartDataSecondary = (e) => ({
  type: CLEAR_STORAGED_CHART_DATA_SECONDARY,
  payload: e,
});
